import { render, staticRenderFns } from "./ActivityConfigDialog.vue?vue&type=template&id=b7b7de76&scoped=true"
import script from "./ActivityConfigDialog.vue?vue&type=script&lang=js"
export * from "./ActivityConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./ActivityConfigDialog.vue?vue&type=style&index=0&id=b7b7de76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b7de76",
  null
  
)

export default component.exports